/**
 * King Living RangeSlider Theme
 *
 * Global range slider styling system supporting:
 * - Dual value range slider
 * - Dark brown/bronze filled track between thumbs (brandColors.primaryDarkLinen)
 * - Light grey unfilled track (brandColors.greyscale10)
 * - White thumbs with dark grey border (brandColors.greyscale)
 *
 * @override Extends Chakra UI RangeSlider theme
 */

const RangeSlider = {
  parts: ['container', 'track', 'filledTrack', 'thumb', 'mark'],
  baseStyle: {
    track: {
      bg: 'brandColors.greyscale10', // Light grey for unfilled track
      h: '4px', // Track height
      borderRadius: '4px',
    },
    filledTrack: {
      bg: 'brandColors.primaryDarkLinen', // Dark brown/bronze for filled track
    },
    thumb: {
      w: '14px', // 14px
      h: '14px', // 14px
      bg: 'white', // White background
      border: '1px solid',
      borderColor: 'brandColors.greyscale', // Dark grey border
      borderRadius: 'full', // Circular
      _focus: {
        boxShadow: 'none',
        outline: 'none',
      },
      _active: {
        boxShadow: 'none',
      },
    },
  },
};

export default RangeSlider;
